// Apresentação do GMD (Ganho Médio Diário) em g/dia.
//
// O GMD é armazenado e trafega da API em kg/dia (unidade interna, herdada do peso em kg).
// Como o ganho de um cordeiro normalmente é < 1 kg/dia, a apresentação ao usuário é SEMPRE
// em g/dia (58 g/d em vez de 0,058 kg/d) — regra de negócio v1.6. Este é o único lugar que
// deve fazer essa conversão; nenhuma tela deve formatar "kg/d" diretamente.

/** kg/dia (número ou string) -> g/dia (número). null se não houver valor. */
export function kgToGd(kg) {
  if (kg == null || kg === '') return null;
  const n = parseFloat(kg);
  return isNaN(n) ? null : n * 1000;
}

/** kg/dia -> '58 g/d' | '—' se não houver valor. */
export function formatGd(kg) {
  const g = kgToGd(kg);
  return g == null ? '—' : `${Math.round(g)} g/d`;
}

/** Direção da seta = SINAL do GMD (independe do desempenho/cor). */
export function direcaoGmd(kg) {
  if (kg == null || kg === '' || isNaN(parseFloat(kg))) return 'flat';
  const n = parseFloat(kg);
  if (n > 0) return 'up';
  if (n < 0) return 'down';
  return 'flat';
}

// Paleta padrão da classificação de desempenho — mesma usada nas telas de GMD.
export const CORES_GMD = {
  verde:    { color: '#16a34a', bg: '#dcfce7', label: 'Verde' },
  amarelo:  { color: '#f59e0b', bg: '#fef3c7', label: 'Amarelo' },
  vermelho: { color: '#dc2626', bg: '#fee2e2', label: 'Vermelho' },
};

/**
 * Classificação por desempenho (verde/amarelo/vermelho), config-driven em g/dia.
 * cfg = objeto de configurações (context), com gmd_verde_min_g e gmd_amarelo_min_g.
 * Independe do sinal — um GMD positivo e baixo pode classificar como vermelho.
 */
export function classificarGmd(kg, cfg) {
  const g = kgToGd(kg);
  if (g == null) return null;
  const verdeMin = parseFloat(cfg?.gmd_verde_min_g ?? 150);
  const amareloMin = parseFloat(cfg?.gmd_amarelo_min_g ?? 100);
  if (g >= verdeMin) return 'verde';
  if (g >= amareloMin) return 'amarelo';
  return 'vermelho';
}

/** Limiares (g/d) já convertidos, prontos para exibir na legenda. */
export function limiaresGmd(cfg) {
  return {
    verdeMin: parseFloat(cfg?.gmd_verde_min_g ?? 150),
    amareloMin: parseFloat(cfg?.gmd_amarelo_min_g ?? 100),
  };
}
